import type { INivel } from '@/shared/insaculacion/entity-commons/entity.factory';
import { EstadoRevision } from '@/shared/model/enumerations/estado-revision.model';
import { NRecomendadoEnum } from '@/shared/model/enumerations/nivel-recomendado-enum.model';
import { NivelSni } from '@/shared/model/enumerations/niveles-sni.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { Expediente } from '@conacyt/historicopersonasms-client';
import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue2Filters from 'vue2-filters';
import { mapGetters, mapMutations } from 'vuex';
import RevisionMixin from '../mixins/revision-mixin';
import SolucionMixin from '../mixins/solucion-mixin';

import VigenciasSniComponent from '@/components/expediente-persona/vigencias-sni/vigencias-sni.vue';
import HomeMenuComponent from '@/components/home-menu/home-menu.component';
import EntityFactory from '@/shared/insaculacion/entity-commons/entity.factory';
import { TipoRevision } from '@/shared/model/enumerations/tipo-revision.model';

@Component({
  components: {
    'vigencias-sni': VigenciasSniComponent,
  },
  mixins: [Vue2Filters.mixin],
  computed: {
    ...mapGetters(['evaluacion', 'revisorSeleccionado']),
  },
  methods: {
    ...mapMutations(['setDictamen', 'setEvaluacion']),
  },
})
export default class EvaluacionIndividual2026Component extends mixins(RevisionMixin, SolucionMixin, HomeMenuComponent) {
  @Prop({ required: true })
  public revision;

  @Prop({ required: true })
  public solicitud: Solicitud;

  public expediente: Expediente = {} as Expediente;

  public evaluacion: INivel = {};

  public plenariaId = '';

  public readonly revisorSeleccionado: number;

  public aceptada = EstadoRevision.ACEPTADA;
  public revisada = EstadoRevision.REVISADA;

  public readonly nivelCandidato: string = '1';

  public static readonly CANCELADO = 'CANCELADO';

  public static readonly CLAVE_TIPO_EVALUACION = '0';

  public static readonly CLAVE_TIPO_EVALUACION_REVISORA = '26';
  /* NUEVO 2026 */
  public confirmaNivelSugerido = '';
  public mostrarFormularioExcepcion = false;

  public mostrarSeccionExcepcion = false;
  public segundaOportunidadUsada = false;

  public resaltarTablaSegundaOportunidad = false;

  public evaluacionGuardadaFinal = false;

  public mostrarAlertaSemaforo = false;
  public mensajeAlertaSemaforo = '';
  public timeoutAlertaSemaforo: any = null;
  public nivelExcepcionSeleccionado: any = null;

  public nivelRecomendadoNoAplicable: Array<NRecomendadoEnum> = [
    NRecomendadoEnum.NO_APROBADO,
    NRecomendadoEnum.NIVEL_CANDIDATO,
    NRecomendadoEnum.NIVEL_I,
  ];

  /* NUEVO 2026 */
  public opcionesValoracionCualitativa: string[] = ['Muy baja', 'Baja', 'Moderada', 'Alta', 'Muy alta'];

  public opcionesBaseValoracionCualitativaDefault: any[] = [
    { text: 'Muy baja', value: 1, clase: 'muy-baja', disabled: false },
    { text: 'Baja', value: 2, clase: 'baja', disabled: false },
    { text: 'Moderada', value: 3, clase: 'moderada', disabled: false },
    { text: 'Alta', value: 4, clase: 'alta', disabled: false },
    { text: 'Muy alta', value: 5, clase: 'muy-alta', disabled: false },
  ];

  public opcionesBaseValoracionCualitativaEspeciales: any[] = [
    { text: 'Muy baja', value: 0, clase: 'muy-baja', disabled: false },
    { text: 'Baja', value: 0, clase: 'baja', disabled: false },
    { text: 'Moderada', value: 1, clase: 'moderada', disabled: false },
    { text: 'Alta', value: 2, clase: 'alta', disabled: false },
    { text: 'Muy alta', value: 3, clase: 'muy-alta', disabled: false },
  ];

  public opcionesValoracionCualitativaPorCampo(campo: string): any[] {
    if (
      campo === 'sostenida' &&
      (this.solicitudRizomaActual.nivelAspirarParametros.id === '1' || this.solicitudRizomaActual.nivelAspirarParametros.id === '5')
    ) {
      return this.opcionesBaseValoracionCualitativaEspeciales.map(opcion => ({
        text: opcion.text,
        value: {
          text: opcion.text,
          value: opcion.value,
        },
        disabled: opcion.disabled || this.tablaCualitativaBloqueada,
        clase: opcion.clase,
      }));
    } else if (campo === 'diversa') {
      return this.opcionesBaseValoracionCualitativaEspeciales.map(opcion => ({
        text: opcion.text,
        value: {
          text: opcion.text,
          value: opcion.value,
        },
        disabled: opcion.disabled || this.tablaCualitativaBloqueada,
        clase: opcion.clase,
      }));
    } else {
      return this.opcionesBaseValoracionCualitativaDefault.map(opcion => ({
        text: opcion.text,
        value: {
          text: opcion.text,
          value: opcion.value,
        },
        disabled: opcion.disabled || this.tablaCualitativaBloqueada,
        clase: opcion.clase,
      }));
    }
  }

  /**
   * Guarda las valoraciones recuperadas con descripción y valor.
   * Sirve para consultar el dato completo después de recuperar la información.
   *
   * Ejemplo:
   * relevante: {
   *   descripcion: "Alta",
   *   valor: 4
   * }
   */
  public valoracionesCualitativasCompletas: any = {};

  /**
   * Mutación del store para guardar la evaluación
   */
  setEvaluacion!: (evaluacion: INivel) => void;

  setDictamen!: (dictamen: any) => void;

  mounted(): void {
    this.get();
    this.validaCandidato();
    this.getDefinicionRevision(this.solicitud.solucionId);
    this.getEvaluacionIdPlenariaIndividual();
  }

  /**
   * Carga inicial del componente
   *
   * @memberof EvaluacionIndividualComponet
   */
  get(): void {
    if (this.solicitud && this.revision) {
      const respuesta: any = this.revision?.respuesta;
      const properties: any = respuesta?.properties || respuesta || {};

      if (properties?.evaluacion) {
        this.recomendado = properties.evaluacion;
        this.evaluacion = properties.evaluacion;
      } else if (this.evaluacion?.id) {
        this.recomendado = this.evaluacion;
        this.evaluacion = properties.evaluacion;
      }

      if (this.revision?.respuesta?.resumen && !this.evaluacionIndividual) {
        this.resumen = this.revision?.respuesta?.resumen;
      }

      if (properties?.clonado && properties?.evaluacionGuardadaFinal) {
        this.clonado = properties.clonado;
        this.mostrarComponente();
      }

      if (properties?.evaluacion3 && (this.segundaOportunidadActiva || properties?.segundaOportunidadActiva)) {
        this.evaluacion3 = properties.evaluacion3;
      }

      if (properties?.evaluacion2 && (this.segundaOportunidadActiva || properties?.segundaOportunidadActiva)) {
        this.evaluacion2 = properties.evaluacion2;
      }
      if (properties?.evaluacion1 && (!this.segundaOportunidadActiva || !properties?.segundaOportunidadActiva)) {
        this.evaluacion1 = properties.evaluacion1;
      }

      if (properties?.segundaOportunidadActiva) {
        this.segundaOportunidadActiva = properties?.segundaOportunidadActiva;
      } else {
        this.segundaOportunidadActiva = false;
      }

      if (properties?.esExcepcion) {
        this.mostrarFormularioExcepcion = properties?.esExcepcion;
      } else {
        this.mostrarFormularioExcepcion = false;
      }
      /**
       * Carga las valoraciones cualitativas guardadas para que
       * la tabla quede pintada al cambiar de sección o recargar.
       */
      if (
        properties?.valoracionesCualitativasPrimera &&
        properties?.evaluacionGuardada1 &&
        (!this.segundaOportunidadActiva || !properties?.segundaOportunidadActiva)
      ) {
        this.cargarValoracionesCualitativasGuardadas(properties.valoracionesCualitativasPrimera);
      } else if (properties?.valoracionesCualitativasSegunda && (this.segundaOportunidadActiva || properties?.segundaOportunidadActiva)) {
        this.cargarValoracionesCualitativasGuardadas(properties.valoracionesCualitativasSegunda);
      }

      if (properties?.evaluacionGuardadaFinal) {
        this.evaluacionGuardadaFinal = true;
      } else {
        this.evaluacionGuardadaFinal = false;
      }

      // if (properties?.segundaOportunidadActiva && !this.evaluacion2.id) {
      //   this.tablaCualitativaBloqueada = false;
      // } else {
      //     this.tablaCualitativaBloqueada = true;
      // }
      /**
       * Si la evaluación ya fue guardada, se restaura el estado
       * para que todo quede congelado y con los datos visibles.
       */
      if (properties?.evaluacionGuardada1 && (!this.segundaOportunidadActiva || !properties?.segundaOportunidadActiva)) {
        this.evaluacionGuardada1 = true;
        this.confirmaNivelSugerido = properties?.confirmaNivelSugerido || '';
        this.mostrarFormularioExcepcion = !!properties?.esExcepcion;
        this.segundaOportunidadUsada = properties?.segundaOportunidadUsada;
        this.tablaCualitativaBloqueada = true;
        this.nivelExcepcionSeleccionado = properties?.nivelExcepcion || null;
      } else {
        this.evaluacionGuardada1 = false;
        this.confirmaNivelSugerido = '';
        this.mostrarFormularioExcepcion = false;

        this.segundaOportunidadUsada = false;
        this.nivelExcepcionSeleccionado = null;
      }

      if (properties?.evaluacionGuardada2 && (this.segundaOportunidadActiva || properties?.segundaOportunidadActiva)) {
        this.evaluacionGuardada1 = true;
        this.evaluacionGuardada2 = true;
        this.confirmaNivelSugerido = properties?.confirmaNivelSugerido || '';
        this.mostrarFormularioExcepcion = !!properties?.esExcepcion;
        this.segundaOportunidadUsada = properties?.segundaOportunidadUsada;

        this.tablaCualitativaBloqueada = true;
        this.nivelExcepcionSeleccionado = properties?.nivelExcepcion || null;
      } else {
        this.evaluacionGuardada2 = false;
        this.confirmaNivelSugerido = '';
        this.mostrarFormularioExcepcion = false;

        this.segundaOportunidadUsada = false;
        this.nivelExcepcionSeleccionado = null;
      }
    }
  }

  /**
   * Oculta el campo Candidato si tieneCandidato es igual a true
   *
   * @memberof EvaluacionIndividualComponet
   */
  @Watch('tieneCandidato')
  public esCandidato(newValue: boolean): void {
    if (newValue && this.revision.estado === this.aceptada) {
      this.nivelRecomendado = this.nivelRecomendado.slice(1);
    }
  }

  /**
   * Guarda el nivel recomendado de SNI
   *
   * @memberof EvaluacionIndividualComponet
   */
  @Watch('nivelExcepcionSeleccionado')
  public guardaNivelExcepcion(): void {
    let datosEnviar = {};
    this.setDictamen({});

    if (this.evaluacionGuardadaFinal) {
      return;
    }

    if (this.evaluacionIndividual) {
      datosEnviar = {
        dictamen: {},
        valido: false,
        evaluacion: this.nivelExcepcionSeleccionado,

        // Aquí se guarda el nivel otorgado por excepción
        nivelExcepcion: this.nivelExcepcionSeleccionado,

        // Bandera para congelar después de recargar
        evaluacionGuardadaFinal: true,
      };
    } else {
      this.recomendado = this.nivelExcepcionSeleccionado;

      this.calcularPrelacionPlenaria2026();

      datosEnviar = {
        valido: false,
        evaluacion: this.nivelExcepcionSeleccionado,

        // Aquí se guarda el nivel otorgado por excepción
        nivelExcepcion: this.nivelExcepcionSeleccionado,

        //agrega prelación
        resumen: this.resumen,

        // Bandera para congelar después de recargar
        evaluacionGuardadaFinal: true,
      };
    }

    this.guardaEvaluacion(datosEnviar);

    this.evaluacionGuardadaFinal = true;
  }

  /**
   *
   * Esta función crea un objeto con datos de evaluación, dictamen
   *  y la variable 'valido' con estado 'false',
   *  @memberof EvaluacionIndividualComponet
   */
  public cambioNivel(): void {
    let datosEnviar = {};
    datosEnviar = {
      evaluacion: {},
      dictamen: {},
      valido: false,
    };
    this.setDictamen({});
    this.guardaEvaluacion(datosEnviar);
  }

  /**
   * Muestra una alerta temporal en pantalla con el mensaje recibido.
   */
  public mostrarMensajeAlertaSemaforo(mensaje: string): void {
    this.mensajeAlertaSemaforo = mensaje;
    this.mostrarAlertaSemaforo = true;

    if (this.timeoutAlertaSemaforo) {
      clearTimeout(this.timeoutAlertaSemaforo);
    }

    this.timeoutAlertaSemaforo = setTimeout(() => {
      this.mostrarAlertaSemaforo = false;
    }, 4000);
  }

  /**
   * Controla la acción de los botones Sí / No para confirmar el nivel sugerido.
   *
   * - Si presiona "Sí", acepta el nivel sugerido y se oculta el formulario de excepción.
   * - Si presiona "No" por primera vez, activa la segunda oportunidad y limpia la valoración.
   * - Si presiona "No" después de usar la segunda oportunidad, permite mostrar el botón Excepción.
   */
  public confirmarNivelSugerido(valor: string): void {
    if ((valor === 'SI' || valor === 'NO') && !this.todasValoracionesCapturadas) {
      this.mostrarMensajeAlertaSemaforo('Debe completar la valoración cualitativa de todos los componentes antes de continuar.');

      this.confirmaNivelSugerido = '';
      this.mostrarFormularioExcepcion = false;

      return;
    }

    let datosEnviar = {};

    if (valor === 'SI' && !this.segundaOportunidadActiva) {
      this.confirmaNivelSugerido = 'SI';
      this.mostrarFormularioExcepcion = false;

      this.segundaOportunidadActiva = false;
      this.evaluacionGuardadaFinal = true;
      datosEnviar = {
        evaluacionGuardadaFinal: true,
      };

      this.guardaEvaluacion(datosEnviar);
      this.mostrarBotonesConfirmacion();
      return;
    } else if (valor === 'SI' && this.segundaOportunidadActiva) {
      this.confirmaNivelSugerido = 'SI';
      this.mostrarFormularioExcepcion = false;

      this.segundaOportunidadActiva = true;
      this.evaluacionGuardadaFinal = true;
      datosEnviar = {
        evaluacionGuardadaFinal: true,
      };

      this.guardaEvaluacion(datosEnviar);
      this.mostrarBotonesConfirmacion();
      return;
    }
    if (valor === 'NO' && !this.segundaOportunidadActiva) {
      this.segundaOportunidadUsada = true;
      this.segundaOportunidadActiva = true;
      this.tablaCualitativaBloqueada = false;

      this.confirmaNivelSugerido = '';
      this.mostrarFormularioExcepcion = false;

      this.recomendado = {};
      this.tieneCandidato = false;
      this.mostrarTieneCandidato = false;

      this.limpiarValoracionCualitativa();
      this.enviarUsuarioATablaCualitativa();
      const datosEnviarse: any = {
        segundaOportunidadActiva: true,
      };

      if (!this.evaluacionIndividual) {
        datosEnviarse.resumen = '';
      }

      this.guardaEvaluacion(datosEnviarse);
      this.mostrarBotonesConfirmacion();
    } else if (valor === 'NO' && this.segundaOportunidadActiva) {
      this.confirmaNivelSugerido = 'NO';
      this.mostrarSeccionExcepcion = true;
    }
  }

  /**
   * Obtiene el id del tipo de perfil actual.
   */
  get tipoPerfilActualId(): string {
    return this.solicitudRizomaActual?.tipoPerfil?.id || '';
  }

  public mostrarBotonesConfirmacion(): boolean {
    if (this.evaluacion2?.id === '4') {
      return false;
    } else if (this.tablaCualitativaBloqueada && (this.mostrarFormularioExcepcion || this.mostrarSeccionExcepcion)) {
      return false;
    } else if (this.tablaCualitativaBloqueada && !this.evaluacionGuardadaFinal) {
      return true;
    } else if (this.evaluacionGuardadaFinal) {
      return false;
    }
    return false;
  }

  /**
   * Genera la clave que indica qué texto descriptivo mostrar en pantalla.
   * Combina el tipo de perfil y el nivel sugerido.
   *
   * Ejemplo:
   * tipoPerfilActualId = "a"
   * nivelSugeridoActualId = "1"
   * resultado = "a_1"
   */
  get claveDescripcionNivelSugerido(): string {
    if (!this.tipoPerfilActualId) {
      return '';
    }
    let idNivel;
    if (this.revision?.respuesta?.nivelExcepcion?.id) {
      idNivel = this.revision?.respuesta?.nivelExcepcion?.id;
    } else if (this.revision?.respuesta?.evaluacion3?.id) {
      idNivel = this.revision?.respuesta?.evaluacion3?.id;
    } else if (this.revision?.respuesta?.evaluacion2?.id) {
      idNivel = this.revision?.respuesta?.evaluacion2?.id;
    } else if (this.revision?.respuesta?.evaluacion1?.id) {
      idNivel = this.revision?.respuesta?.evaluacion1?.id;
    }

    if (!idNivel) {
      return '';
    }

    return `${this.tipoPerfilActualId}_${idNivel}`;
  }

  /**
   * Limpia la valoración cualitativa capturada.
   * Se usa cuando el usuario tiene una segunda oportunidad para evaluar.
   */
  public limpiarValoracionCualitativa(): void {
    this.valoracionesCualitativas = {
      relevante: null,
      pertinente: null,
      sostenida: null,
      diversa: null,

      comprometidoFormacion: null,
      colaborativo: null,
      constante: null,

      inclusivaGratuita: null,
      comprensible: null,
    };

    this.valoracionesCualitativasCompletas = {};

    this.setEvaluacion({});
    this.setDictamen({});

    this.tablaCualitativaBloqueada = false;
  }

  /**
   * Envía al usuario de regreso a la tabla de valoración cualitativa.
   * Se usa cuando tiene una segunda oportunidad para evaluar.
   */
  private enviarUsuarioATablaCualitativa(): void {
    this.$nextTick(() => {
      const tabla = this.$refs.tablaValoracionCualitativa as HTMLElement;

      if (tabla) {
        tabla.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }

      this.resaltarTablaSegundaOportunidad = true;

      setTimeout(() => {
        this.resaltarTablaSegundaOportunidad = false;
      }, 3000);
    });
  }

  /**
   * Muestra el botón Guardar cuando el flujo ya está listo para guardar.
   *
   * Se muestra si:
   * - El usuario confirma el nivel sugerido con "Sí".
   * - El usuario rechaza el nivel sugerido con "No" y abre el formulario de excepción.
   */
  get mostrarBotonGuardarResultado(): boolean {
    return this.confirmaNivelSugerido === 'SI' || (this.confirmaNivelSugerido === 'NO' && this.mostrarFormularioExcepcion);
  }

  /**
   * Deshabilita el botón Guardar según el flujo seleccionado.
   *
   * - Si confirma "Sí", permite guardar.
   * - Si confirma "No" y abrió excepción, exige seleccionar un nivel por excepción.
   * - En cualquier otro caso, mantiene Guardar deshabilitado.
   */
  get deshabilitarGuardarResultado(): boolean {
    if (this.confirmaNivelSugerido === 'SI') {
      return false;
    }

    if (this.confirmaNivelSugerido === 'NO' && this.mostrarFormularioExcepcion) {
      return !this.nivelExcepcionSeleccionado;
    }

    return true;
  }

  /**
   * Muestra el botón Excepción cuando:
   *
   * - El usuario ya rechazó el nivel sugerido.
   * - Ya usó la segunda oportunidad.
   * - Ya completó todas las valoraciones cualitativas.
   */
  get mostrarBotonExcepcion(): boolean {
    if (this.evaluacionGuardadaFinal) {
      return false;
    } else if (this.evaluacion2?.id === '4') {
      return false;
    } else if (this.evaluacionGuardada2 && this.mostrarSeccionExcepcion && !this.mostrarFormularioExcepcion) {
      return true;
    } else if (this.mostrarFormularioExcepcion) {
      return false;
    }
    return false;
  }

  get mostrarBotonNoAprobado(): boolean {
    if (this.evaluacionGuardadaFinal) {
      return false;
    } else if (this.evaluacion2?.id === '5') {
      return false;
    } else if (this.evaluacionGuardada2 && this.mostrarSeccionExcepcion && !this.mostrarFormularioExcepcion) {
      return true;
    } else if (this.mostrarFormularioExcepcion) {
      return false;
    }
    return false;
  }

  /**
   * Guarda la variable esExcepcion
   */
  public mostrarExcepcion(): void {
    let datosEnviar = {};

    this.mostrarSeccionExcepcion = true;
    this.mostrarFormularioExcepcion = true;

    datosEnviar = {
      esExcepcion: true,
    };

    this.guardaEvaluacion(datosEnviar);
  }

  /**
   * Guarda la variable esExcepcion
   */
  public guardarNivelNoAprobado(): void {
    let datosEnviar = {};

    this.evaluacion3 = EntityFactory.nivelesRecomendado.find(ac => ac.id === this.idNoAprobado) ?? {};

    datosEnviar = {
      evaluacion: this.evaluacion3,
      evaluacion3: this.evaluacion3,
      evaluacionGuardadaFinal: true,
      resumen: 'No aplica',
    };

    this.resumen = 'No aplica';
    this.evaluacionGuardadaFinal = true;

    this.guardaEvaluacion(datosEnviar);
  }

  /**
   * Obtiene los niveles que se pueden seleccionar por excepción
   * tomando como base el resultado de evaluacion2.
   *
   * Reglas:
   * - No Aprobado / id 5 -> Candidato, Nivel I, Nivel II, Nivel III
   * - Candidato / id 1 -> Nivel I, Nivel II, Nivel III
   * - Nivel I / id 2 -> Nivel II, Nivel III
   * - Nivel II / id 3 -> Nivel III
   * - Nivel III / id 4 -> ninguno
   */
  get nivelesExcepcionDisponibles(): any[] {
    const niveles = this.nivelesBaseExcepcion || [];

    let idsPermitidos;

    const evaluacion2Id = String((this as any).evaluacion2?.id || '');

    const nivelesPermitidosPorEvaluacion2: Record<string, string[]> = {
      '5': ['1', '2', '3', '4'],
      '1': ['2', '3', '4'],
      '2': ['3', '4'],
      '3': ['4'],
      '4': [],
    };

    idsPermitidos = nivelesPermitidosPorEvaluacion2[evaluacion2Id] || [];

    console.log('idsPermitidos:', idsPermitidos);
    if (evaluacion2Id === '5') {
      const tieneCandidatoEnVigencia = Boolean((this as any).tieneCandidato);

      if (tieneCandidatoEnVigencia) {
        idsPermitidos = idsPermitidos.filter(id => id !== '1');
      }
    }
    return niveles.filter((nivel: any) => idsPermitidos.includes(String(nivel.id)));
  }

  /**
   * Catálogo base de niveles para excepción.
   */
  get nivelesBaseExcepcion(): any[] {
    return [
      { id: '1', nombre: 'Candidato' },
      { id: '2', nombre: 'Investigador Nacional Nivel I' },
      { id: '3', nombre: 'Investigador Nacional Nivel II' },
      { id: '4', nombre: 'Investigador Nacional Nivel III' },
    ];
  }

  /**
   * Niveles disponibles para aprobación normal.
   *
   * Si ya tiene Candidato:
   * muestra Nivel I, Nivel II y Nivel III.
   *
   * Si no tiene Candidato:
   * muestra Candidato, Nivel I, Nivel II y Nivel III.
   */
  get nivelesAprobacionDisponibles(): any[] {
    const niveles = this.nivelRecomendado || [];

    if (this.tieneCandidato) {
      return niveles.filter((nivel: any) => ['2', '3', '4'].includes(String(nivel.id)));
    }

    return niveles.filter((nivel: any) => ['1', '2', '3', '4'].includes(String(nivel.id)));
  }

  /**
   * Carga las valoraciones cualitativas guardadas en la revisión.
   *
   * En base vienen así:
   * relevante: {
   *   descripcion: "Muy baja",
   *   valor: 1
   * }
   *
   * Para pantalla, el v-model usa solo la descripción:
   * "Muy baja"
   *
   * Pero también conservamos descripcion y valor en:
   * valoracionesCualitativasCompletas
   */
  private cargarValoracionesCualitativasGuardadas(valoracionesGuardadas: any): void {
    if (!valoracionesGuardadas) {
      return;
    }

    const valoracionesPantalla: any = {};
    const valoracionesCompletas: any = {};

    Object.keys(this.valoracionesCualitativas).forEach(campo => {
      const valorGuardado = valoracionesGuardadas[campo];

      let descripcion = '';
      let valor: number | null = null;

      if (valorGuardado && typeof valorGuardado === 'object') {
        descripcion = valorGuardado.descripcion || valorGuardado.text || '';
        valor = valorGuardado.valor;
      } else {
        descripcion = valorGuardado || '';
        valor = valorGuardado.valor;
      }

      // Esto pinta la tabla con objeto, no con string
      valoracionesPantalla[campo] = descripcion
        ? {
            text: descripcion,
            value: valor,
          }
        : null;

      // Esto conserva descripcion y valor
      valoracionesCompletas[campo] = {
        descripcion,
        valor,
      };
    });

    this.valoracionesCualitativas = {
      ...this.valoracionesCualitativas,
      ...valoracionesPantalla,
    };

    this.valoracionesCualitativasCompletas = {
      ...this.valoracionesCualitativasCompletas,
      ...valoracionesCompletas,
    };
  }

  public mostrarTextos(): boolean {
    if (this.mostrarFormularioExcepcion) {
      return false;
    } else if (
      (this.confirmaNivelSugerido == 'NO' && !this.evaluacion3.id) ||
      (this.segundaOportunidadActiva && !this.evaluacionGuardada2)
    ) {
      return false;
    } else if (this.evaluacion3.id == '5' || this.evaluacion2.id == '5' || this.evaluacion1.id == '5') {
      return true;
    } else if (this.evaluacion1.id || this.evaluacion2.id || this.evaluacionGuardada2) {
      return true;
    }
    return false;
  }

  /**
   * Obtiene la defición evaluación
   */
  @Watch('definicionEvaluacion')
  public getEvaluacionIdPlenariaIndividual(): void {
    if (this.definicionEvaluacion) {
      for (const definicion of this.definicionEvaluacion.revisiones) {
        if (definicion.tipoRevision === TipoRevision.PLENARIA) {
          this.plenariaId = definicion.id;
        }
      }
    }

    if (this.revision?.evaluacionId === this.plenariaId) {
      this.isPleno = true;
    } else {
      this.isPleno = false;
    }
  }

  /**
   * Valida si se desea mostrar el componente
   */
  public mostrarComponente(): boolean {
    if (this.isPleno && this.clonado) {
      return true;
    } else if (!this.isPleno) {
      return true;
    } else if (this.isPleno && this.revision?.respuesta?.clonado === false) {
      return true;
    }
    return false;
  }
}
